export default __webpack_public_path__ + "static/media/About-3.80b6f62a.jpg";